"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var EmojiAdd = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_EmojiAdd_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.5a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2v-2a.5.5 0 0 0-1 0v2h-2a.5.5 0 0 0 0 1h2v2ZM7.25 2.5a6.25 6.25 0 1 0 6.25 6.25.5.5 0 0 1 1 0A7.25 7.25 0 1 1 7.25 1.5a.5.5 0 0 1 0 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8.75a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM9.501 8.75a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM4.982 10.879a.5.5 0 1 0-.863.505c.297.507.806.87 1.35 1.104.549.237 1.179.362 1.782.362s1.233-.125 1.782-.362c.544-.234 1.053-.597 1.35-1.104a.5.5 0 1 0-.864-.505c-.153.261-.456.508-.881.69-.42.181-.915.281-1.387.281-.473 0-.967-.1-1.387-.28-.425-.183-.728-.43-.882-.691Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_EmojiAdd_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = EmojiAdd;
exports["default"] = _default;